const Programacao = () => {
    const components = document.querySelectorAll('[data-component="programacao"]');
    components.forEach(component => {
        const buttons = component.querySelectorAll('nav [data-tab]');
        const tabs = component.querySelectorAll('.tab');
        const selectTabMobile = component.querySelector('.select');
        const navMobile = component.querySelector('.nav-mobile');

        selectTabMobile.addEventListener('click', () => {
            navMobile.classList.toggle('active');
        });

        buttons.forEach((el) => {
            el.addEventListener('click', (button) => {
                buttons.forEach((button) => {
                    button.classList.remove('active');
                });

                tabs.forEach((tab) => {
                    tab.classList.remove('active');
                });

                selectTabMobile.querySelector('span').innerText = button.currentTarget.innerText;

                navMobile.classList.remove('active');
                button.currentTarget.classList.add('active');
                document.getElementById(button.currentTarget.dataset.tab).classList.add('active');
            })
        });
    });
};

export default Programacao;

if (document.querySelectorAll('[data-component="programacao"]')) {
    Programacao();
}
